import { render, staticRenderFns } from "./PropertyCarFieldset.vue?vue&type=template&id=4bb3a57e&scoped=true"
import script from "./PropertyCarFieldset.vue?vue&type=script&lang=js"
export * from "./PropertyCarFieldset.vue?vue&type=script&lang=js"
import style0 from "./PropertyCarFieldset.vue?vue&type=style&index=0&id=4bb3a57e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3a57e",
  null
  
)

export default component.exports